import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { COLORS, typographyStyles } from '@livecommerce/design-system';

const ValueWrapper = styled.div`
  ${typographyStyles.getBodyText(10, 500)}
  padding: 2px;
  min-width: 18px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
  background-color: ${COLORS.white};
  color: ${COLORS.dark_700};
  border-radius: 16px;
`;

const NumberIndicator = ({ valueKey, ...props }) => {
  const value = useSelector((state) => state.ui.numberIndicators[valueKey]);
  if (!value) return null;
  return (
    <ValueWrapper {...props}>
      {value}
    </ValueWrapper>
  );
};

export default NumberIndicator;
